import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

export default function AssetCustomFieldInputs({ fields = [], values = {}, onChange }) {
  if (!fields.length) return null;
  return (
    <Box sx={{ width: "100%", mt: 0.5, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 2 }}>
        {fields.map((field) => (
          <Box key={field.id || field.field_key} sx={{ minWidth: 0 }}>
            {field.field_type === "DROPDOWN" ? (
              <FormControl size="small" fullWidth sx={{ bgcolor: "white" }}>
                <InputLabel>{field.label}</InputLabel>
                <Select
                  label={field.label}
                  value={values?.[field.field_key] || ""}
                  onChange={(event) => onChange(field.field_key, event.target.value)}
                >
                  <MenuItem value=""><em>Not set</em></MenuItem>
                  {(field.options || []).map((option) => <MenuItem key={option} value={option}>{option}</MenuItem>)}
                </Select>
              </FormControl>
            ) : (
              <TextField
                size="small"
                fullWidth
                label={field.label}
                value={values?.[field.field_key] || ""}
                onChange={(event) => onChange(field.field_key, event.target.value)}
                inputProps={{ maxLength: 500 }}
                sx={{ bgcolor: "white" }}
              />
            )}
          </Box>
        ))}
    </Box>
  );
}
